module.exports = __webpack_public_path__ + "static/img/8.073bae1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/8.png
// module id = KoA7
// module chunks = 0